import * as React from 'react';

class switchButtonV4 extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.componentName = "[switchButtonV4.jsx] ";
        this.state = {}
    }


    onChange(event) {
        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            event.target.value = event.target.checked;
            this.props.onChange(event);
        }
    }

    render() {
        console.log(this.componentName + 'RENDER: ' + this.props.id);

        let formClass = 'form-check align-self-center ';
        if (this.props.componentClass === null || this.props.componentClass === undefined) {
            formClass = formClass + 'mt-3 col-6 ';
        } else {
            formClass = formClass + this.props.componentClass;
        }

        let name = null;
        if (this.props.name === undefined) {
            name = this.props.id;
        } else {
            name = this.props.name;
        }

        let isDisabled;
        if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
            isDisabled = false;
        } else {
            isDisabled = true;
        }

        let label = null;
        if (this.props.label === undefined) {
            label = name;
        } else {
            label = this.props.label;
        }

        let myValue;
        if (this.props.value === undefined || this.props.value === null) {
            myValue = '';
        } else {
            myValue = this.props.value;
        }

        let visible = true;

        if (!this.props.visible) {
            visible = false;
        }

        return (
            <div className={formClass} >

                <label key='labelSwitch ' style={{ verticalAlign: 'text-bottom' }} className='mr-3' htmlFor={this.props.id} >  {label} </label>
                <label className="switch mb-0" >
                    <input id={this.props.id} name={name} visible={visible} type="checkbox" value={myValue} className={"form-check-input  " + this.props.classNameInput}
                        placeholder={this.props.placeholder} onChange={this.onChange} disabled={isDisabled} checked={myValue} />
                    <span className="slider round"></span>
                </label>

            </div>
        );
    }
};

export default switchButtonV4;